import { getOrThrow, has } from 'quartz/globalState/api';
import { I18N_PROVIDER } from './globalState';

/**
 * Provided for backwards-compatibility with existing apps and libraries that need to pass
 * the provider around.
 *
 * @deprecated Prefer calling registerSplitLang instead.
 */
export const getI18nProvider = () => {
  if (!has(I18N_PROVIDER)) {
    throw new Error('I18n provider not initialized — did you forget to call initializeI18n?');
  }
  return getOrThrow(I18N_PROVIDER);
};

/**
 * Registers a language file with the provider configured by quartz for the current app.
 *
 * @example
 * ```ts
 * import lang from 'i2l?query=sporks!sample-card-library/lang/en.lyaml';
 *
 * await registerSplitLang(lang);
 * ```
 */
export const registerSplitLang = async lang => {
  const i18nProvider = getI18nProvider();

  // Awaiting rather than returning this promise ensures that we don't let
  // users do anything with the resolved value of the promise. This prevents them from
  // coupling tightly to the underlying implementation of the i18n provider.
  await i18nProvider.register(lang);
};
export const getLocaleInfo = () => {
  const i18nProvider = getI18nProvider();
  return i18nProvider.localeInfo;
};